export default function Hero() {
  return (
    <section id="hero" className="relative w-full flex items-center overflow-hidden" style={{ minHeight: "100svh" }}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxurious%20modern%20living%20room%20with%20light%20oak%20vinyl%20plank%20flooring%2C%20minimalist%20white%20furniture%2C%20large%20windows%20with%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20sophisticated%20interior%20design%2C%20high-end%20apartment%2C%20warm%20ambient%20lighting%2C%20ultra%20realistic%20photography&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Ambiente moderno com piso vinílico Vynora"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 md:bg-gradient-to-r md:from-black/65 md:via-black/40 md:to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-10 pt-20 pb-12">
        <div className="max-w-2xl mx-auto md:mx-0 text-center md:text-left">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-amber-700/20 border border-amber-500/40 text-amber-300 text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full mb-4">
            <span className="w-1.5 h-1.5 bg-amber-400 rounded-full inline-block" />
            Direto da Fábrica
          </div>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Transformamos<br />
            <span className="text-amber-400">ambientes.</span><br />
            Valorizamos<br />cada detalhe.
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-xl text-white/80 font-light leading-relaxed mb-7 max-w-lg mx-auto md:mx-0">
            Pisos vinílicos direto da fábrica com qualidade premium para seu lar ou escritório.
          </p>

          {/* CTA */}
          <div className="flex justify-center md:justify-start">
            <a
              href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20tenho%20interesse%20em%20reformar%20meu%20ambiente"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-pulse flex items-center justify-center gap-2 bg-[#F5F0E6]/25 hover:bg-[#F5F0E6]/35 text-white font-semibold text-sm px-7 py-3.5 rounded-full border border-[#F5F0E6]/40 backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" />
              Fale no WhatsApp
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-7">
            {[
              { icon: "ri-shield-check-line", text: "Qualidade garantida" },
              { icon: "ri-truck-line", text: "Entrega rápida" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-1.5 text-white/70 text-xs">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-amber-400 text-sm`} />
                </div>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-5 inset-x-0 flex justify-center">
        <div className="flex flex-col items-center gap-1 text-white/50 animate-bounce">
          <span className="text-xs tracking-widest uppercase">Explore</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-base" />
          </div>
        </div>
      </div>
    </section>
  );
}